<template>
  <v-card class="mb-3">
    <v-card-text class="mb-0 pb-0">
      <v-row>
        <v-col cols="12">
          <el-pastas
            email
            :label="$t('El. pašto adresas')"
            :tooltip="
              `${ntrpaslaugos ? 'NtrPaslaugos. ' : ''}Modalas asmuo. El paštas`
            "
            :readonly="readonly"
            :need="need"
            v-model="pastas"
            :autofocus="autofocus"
            :validate-key="validateKey"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ElAsmuoPastas',
  props: {
    value: String,
    readonly: Boolean,
    autofocus: { type: Boolean, default: false },
    need: { type: Boolean, default: true },
    validateKey: String,
    ntrpaslaugos: { type: Boolean, default: false },
  },
  inject: {
    $validator: '$validator',
  },
  computed: {
    pastas: {
      get() {
        return this.value
      },
      set(elValue) {
        this.$emit('input', elValue)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
</style>
